import styled from 'styled-components';
import WalletHeaderSVG from '../../assets/header/ic-wallet.svg';

const WalletHeaderIcon = styled(WalletHeaderSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '2.8rem'};
  height: ${props => props.height || '3.1rem'};
  fill: ${props => props.color};
  margin: ${props => props.margin};
`;

export default WalletHeaderIcon;
